// @ts-nocheck
/// <reference path="../../../microsoftmaps/microsoft.maps.all.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import * as MapCallouts from './../components/childcomponents/BingMapCallouts';
import { DryMapGrid } from './../components/childcomponents/DryMapGrid';
import { RCUtils } from './../RCUtils';
import pushpingray from '../images/MapPushPins/pushpin_gray.png';
import pushpinyellow from '../images/MapPushPins/pushpin_yellow.png';
import pushpinblue from '../images/MapPushPins/pushpin_blue.png';
import pushpingreen from '../images/MapPushPins/pushpin_green.png';
import pushpinred from '../images/MapPushPins/pushpin_red.png';
import pushpin_green_yellow from '../images/MapPushPins/pushpin_green_yellow.png';
import pushpin_blue_yellow from '../images/MapPushPins/pushpin_blue_yellow.png';
import { initialize, whenLoaded } from "bing-maps-loader";

//import { loadBingApi, Microsoft } from "../actions/BingMapLoader";
//import '../actions/bingmaps.api';
//require('../actions/bingmaps.api.js');
var Config: any = require('../Config.json');

var pinInfobox = null;
var toolTip = null;
var reeferHistoryMap = null;
var layer = null;
var traceLayer = null;
var geoZonesLayer = null;
var PushpinsData = [];
var gridName = null;
var calloutState = true;
var reeferMasterData = null;

class MapCallout {
    static InitializeMap(params: any) {
        whenLoaded.then(() => {
            reeferHistoryMap = new Microsoft.Maps.Map(document.getElementById(params), {
                credentials: Config.BingMapsKey,
                //center: new Microsoft.Maps.Location(latitude, longitude),
                mapTypeId: Microsoft.Maps.MapTypeId.road,
                zoom: 12,
                showMapTypeSelector: true
            });

            Microsoft.Maps.Events.addHandler(reeferDetailsMap, 'maptypechanged', function (args) {
                mapTypeChanged(args);
            });
        });

        //var bounds = Microsoft.Maps.LocationRect.fromCorners(new Microsoft.Maps.Location(40.5, -123.5), new Microsoft.Maps.Location(40, -123));
        //var overlay = new PanningOverlay(bounds);
        //reeferHistoryMap.layers.insert(overlay);

    }
  
    static ClearMapPushpins () {
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();

        ClearMapLayers();

        calloutState = true;
    }
     
    static ResetCalloutState(){
        calloutState = true;
    }

    static BindTraceMapPushpins(selectedRows: any, gridType: any, formatterData: any) {
        gridName = gridType;
        reeferMasterData = formatterData;
        PushpinsData = [];
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();
        ClearMapLayers();
        layer = new Microsoft.Maps.Layer();
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.GPSLatitude != null && selectedValue.GPSLongitude != null) {
                var latitude = selectedValue.GPSLatitude;
                var longitude = selectedValue.GPSLongitude;
                
                var imageSource = '';
                if (gridType == "current") {
                    if (selectedValue.GPSLatitude != 0 && selectedValue.GPSLongitude != 0 && ((selectedValue.GPSLockState == null || selectedValue.GPSLockState == "") || selectedValue.GPSLockState.toString().toUpperCase() != "LOCKED"))
                        imageSource = pushpingray;
                    else
                        imageSource = pushpinyellow;
                }
                else {
                    if (selectedValue.GPSLatitude != 0 && selectedValue.GPSLongitude != 0 && ((selectedValue.GPSLockState == null || selectedValue.GPSLockState == "") || selectedValue.GPSLockState.toString().toUpperCase() != "LOCKED"))
                        imageSource = pushpingray;
                    else if (selectedIndex == 0) {
                        //imageSource = pushpinyellow;
                        if (selectedValue.EventMasterID.toString() == "52" && selectedValue.DeviceConfig == true)
                            imageSource = pushpin_green_yellow;
                        else if (selectedValue.EventMasterID.toString() == "53" && selectedValue.DeviceConfig == true)
                            imageSource = pushpin_blue_yellow;
                        else
                            imageSource = pushpinyellow;
                    }
                    //else if (selectedIndex == parseInt(selectedRows.length) - 1)
                    //    imageSource = pushpinblue;
                    //else if (selectedValue.EventMasterID.toString() == "57" || (selectedValue.DeviceType != null && selectedValue.DeviceType.trim() == "CT3100" && selectedValue.EventMasterID.toString() == "52"))
                    //    imageSource = pushpingreen;
                    //else if (selectedValue.EventMasterID.toString() == "58" || (selectedValue.DeviceType != null && selectedValue.DeviceType.trim() == "CT3100" && selectedValue.EventMasterID.toString() == "53"))
                    //    imageSource = pushpinred;
                    else if (selectedValue.EventMasterID.toString() == "52" && selectedValue.DeviceConfig == true)
                        imageSource = pushpingreen;
                    else if (selectedValue.EventMasterID.toString() == "53" && selectedValue.DeviceConfig == true)
                        imageSource = pushpinblue;
                    else
                        imageSource = pushpingray;
                }

                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude);
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
               
                pushpin.setOptions({ color: selectedValue.ParentEventID });
              
                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferHistoryMap);
                // Add handler for the pushpin click event.
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferHistoryInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferHistoryInfoboxOnClick(args); });
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);                
            }
            PushpinsData.push(selectedValue);
        });
        reeferHistoryMap.layers.insert(layer);        
    }
    static DisplaySelectedPushpin(selectedRow: any,reeferMasterData:any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();
        calloutState = false;

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }
        if (selectedRow.GPSLatitude != null && selectedRow.GPSLongitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.GPSLatitude;
            var longitude = selectedRow.GPSLongitude;
            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.ParentEventID == selectedRow.ParentEventID) {
                    rowIndex = index;
                    return false;
                }
            });

            var imageSource = '';
            if (gridName == "current") {
                if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
                    imageSource = pushpingray;
                else
                    imageSource = pushpinyellow;
            }
            else {
                if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
                    imageSource = pushpingray;
                else if (rowIndex == 0) {
                    //imageSource = pushpinyellow;
                    if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                        imageSource = pushpin_green_yellow;
                    else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                        imageSource = pushpin_blue_yellow;
                    else
                        imageSource = pushpinyellow;
                }
                //else if (rowIndex == PushpinsData.length - 1)
                //    imageSource = pushpinblue;
                //else if (selectedRow.EventMasterID.toString() == "57" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "52"))
                //    imageSource = pushpingreen;
                //else if (selectedRow.EventMasterID.toString() == "58" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "53"))
                //    imageSource = pushpinred;
                else if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                    imageSource = pushpingreen;
                else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;
            }

            var pushpinImage = imageSource;

            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);

            pushpin.setOptions({ color: selectedRow.ParentEventID });

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferHistoryMap.setView({
                center: latLong,
                centerOffset: new Microsoft.Maps.Point(0, 50)//RCNG-3126
            });

            pinInfobox.setMap(reeferHistoryMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferHistoryInfobox(args); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferHistoryInfoboxOnClick(args); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferHistoryMap.layers.insert(traceLayer);
        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferHistoryMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferHistoryMap.setView({
                center: center
            });

            toolTip.setMap(reeferHistoryMap);

        }
    }  
    //static DisplaySelectedPushpin(selectedRow: any) {       
    //    if (traceLayer != null)
    //        traceLayer.clear();
    //    traceLayer = new Microsoft.Maps.Layer();
    //    calloutState = false;

    //    if (toolTip != null) {
    //        toolTip.setOptions({ visible: false });
    //        toolTip.setMap(null);
    //    }
    //    if (selectedRow.GPSLatitude != null && selectedRow.GPSLongitude != null) {
    //        if (pinInfobox != null){                
    //            pinInfobox.setOptions({ visible: false });
    //            pinInfobox.setMap(null);
    //        } 

    //        var latitude = selectedRow.GPSLatitude;
    //        var longitude = selectedRow.GPSLongitude;
    //        var rowIndex = 0;
    //        $.each(PushpinsData, function (index, value) {
    //            if (value.ParentEventID == selectedRow.ParentEventID) {
    //                rowIndex = index;
    //                return false;
    //            }
    //        });

    //        var imageSource = '';
    //        if (gridName == "current") {
    //            if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
    //                imageSource = pushpingray;
    //            else
    //                imageSource = pushpinyellow;
    //        }
    //        else {
    //            if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
    //                imageSource = pushpingray;
    //            else if (rowIndex == 0) {
    //                //imageSource = pushpinyellow;
    //                if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
    //                    imageSource = pushpin_green_yellow;
    //                else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
    //                    imageSource = pushpin_blue_yellow;
    //                else
    //                    imageSource = pushpinyellow;
    //            }
    //            //else if (rowIndex == PushpinsData.length - 1)
    //            //    imageSource = pushpinblue;
    //            //else if (selectedRow.EventMasterID.toString() == "57" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "52"))
    //            //    imageSource = pushpingreen;
    //            //else if (selectedRow.EventMasterID.toString() == "58" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "53"))
    //            //    imageSource = pushpinred;
    //            else if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
    //                imageSource = pushpingreen;
    //            else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
    //                imageSource = pushpinblue;
    //            else
    //                imageSource = pushpingray;
    //        }

    //        var pushpinImage = imageSource;

    //        var popOffset = new Microsoft.Maps.Point(-4, 160);
    //        //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
    //        var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
    //        var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
    //        var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);

    //        pushpin.setOptions({ color: selectedRow.ParentEventID });
            
    //        var identityCode = GenerateAlphaNumericCode(6);
    //        /* InfoBox Code Starts     */
    //        var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
    //        var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode, mapName: gridName, alarmData: alarmMasterData });
    //        RCUtils.RenderChildComponent(identityCode, DescElement);
    //        // Create the infobox for the pushpin
    //        pinInfobox = new Microsoft.Maps.Infobox(latLong, {
    //            maxHeight: 200,
    //            maxWidth: 540,
    //            showPointer: true,
    //            description: description,
    //            offset: popOffset,
    //            showCloseButton: true
    //        });
    //        reeferHistoryMap.setView({
    //            center: latLong
    //        });

    //        pinInfobox.setMap(reeferHistoryMap);

    //        Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferHistoryInfobox(args); });
    //        Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferHistoryInfoboxOnClick(args); });

    //        traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
    //        reeferHistoryMap.layers.insert(traceLayer);    
    //    }
    //    else {
    //        if (pinInfobox != null) {
    //            pinInfobox.setOptions({ visible: false });
    //            //pinInfobox.setMap(null);
    //        }
    //        var identityCode = GenerateAlphaNumericCode(6);
    //        var popOffset = new Microsoft.Maps.Point(-120, 100);
    //        /* InfoBox Code Starts     */
    //        var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
    //        var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
    //        RCUtils.RenderChildComponent(identityCode, htmlElement);
    //        /* InfoBox Code Ends     */
    //        var center = reeferHistoryMap.getCenter();
    //        toolTip = new Microsoft.Maps.Infobox(center, {
    //            htmlContent: description,
    //            offset: popOffset,
    //            maxHeight: 50,
    //            maxWidth: 240
    //        });

    //        reeferHistoryMap.setView({
    //            center: center
    //        });

    //        toolTip.setMap(reeferHistoryMap);

    //    }
    //}    
    static BindGensetTraceMapPushpins(selectedRows: any, gridType: any) {
        gridName = gridType;
        PushpinsData = [];
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();
        ClearMapLayers();
        layer = new Microsoft.Maps.Layer();
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;

                //var imageSource = 'genset_normal.png';    
                var imageSource = '';
                if (gridType == "gensetTrace") {
                    if (selectedIndex == 0)
                        imageSource = pushpinyellow;
                    else if (selectedIndex== parseInt(selectedRows.length) - 1)
                        imageSource = pushpinblue;
                    else
                        imageSource = pushpingray;
                }
                else {
                    imageSource = pushpinyellow;
                }

                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude);
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
                //pushpin.setOptions({ color: selectedValue.GensetCurrentConditionId });
                if (gridName == "gensetTrace") {
                    pushpin.setOptions({ color: selectedValue.GensetHistoryID });
                } else {
                    pushpin.setOptions({ color: selectedValue.GensetCurrentConditionId });
                }

                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferHistoryMap);
                // Add handler for the pushpin click event.
                if (gridName == "gensetTrace") {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetHistoryInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetHistoryInfoboxOnClick(args); });
                }
                else {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetStatusInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetStatusInfoboxOnClick(args); });
                }
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);               
            }
            PushpinsData.push(selectedValue);
        });
        reeferHistoryMap.layers.insert(layer);
    }
    
    static BindGeoZonesLayer() {
        if(geoZonesLayer != null)
            geoZonesLayer.clear();
        var selectedDry: any = PushpinsData[0];
        if(selectedDry.Latitude !=null && selectedDry.Longitude !=null && (selectedDry.PositionAccuracy !=null && selectedDry.PositionAccuracy > 0)) {
            geoZonesLayer = new Microsoft.Maps.Layer();
            geoZonesLayer.setZIndex(10400);
            var loc = new Microsoft.Maps.Location(selectedDry.Latitude, selectedDry.Longitude);
            Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
                var paths = Microsoft.Maps.SpatialMath.getRegularPolygon(loc, selectedDry.PositionAccuracy, 36, Microsoft.Maps.SpatialMath.DistanceUnits.Meters);
                var polygon = new Microsoft.Maps.Polygon(paths, null);
                geoZonesLayer.add(polygon);            
                reeferHistoryMap.layers.insert(geoZonesLayer);
            });
        }
    }
 
    static DisposeGeozonesLayer() {
        if (geoZonesLayer != null)
            geoZonesLayer.clear();
    }

    static BindDryTraceMapPushpins(selectedRows: any, gridType: any) {
        gridName = gridType;
        PushpinsData = [];
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();
        ClearMapLayers();
        layer = new Microsoft.Maps.Layer();
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;

                //var imageSource = 'purple_pushpin.png';
                var imageSource = '';
                if (gridType == "dryTrace") {
                    if (selectedIndex == 0)
                        imageSource = pushpinyellow;
                    else if (selectedIndex == parseInt(selectedRows.length) - 1)
                        imageSource = pushpinblue;
                    else
                        imageSource = pushpingray;
                }
                else {
                    imageSource = pushpinyellow;
                }

                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude);
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
                //pushpin.setOptions({ color: selectedValue.GensetCurrentConditionId });
                if (gridName == "dryTrace") {
                    pushpin.setOptions({ color: selectedValue.DCHistoryID });
                } else {
                    pushpin.setOptions({ color: selectedValue.DCCurrentConditionID });
                }

                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferHistoryMap);
                // Add handler for the pushpin click event.
                if (gridName == "dryTrace") {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryHistoryInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryHistoryInfoboxOnClick(args); });
                }
                else {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryStatusInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryStatusInfoboxOnClick(args); });
                }
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);
            }
            PushpinsData.push(selectedValue);
        });
        reeferHistoryMap.layers.insert(layer);
    }

    static BindChassisTraceMapPushpins(selectedRows: any, gridType: any) {
        gridName = gridType;
        PushpinsData = [];
        clearInfoboxPopup();
        ClearMapLayers();
        layer = new Microsoft.Maps.Layer();
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;  
                var imageSource = '';
                if (gridType == "chassisTrace") {
                    if (selectedIndex == 0)
                        imageSource = pushpinyellow;
                    else if (selectedIndex == parseInt(selectedRows.length) - 1)
                        imageSource = pushpinblue;
                    else
                        imageSource = pushpingray;
                }
                else {
                    imageSource = pushpinyellow;
                }

                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude);
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
                if (gridName == "chassisTrace") {
                    pushpin.setOptions({ color: selectedValue.ChassisHistoryID });
                } else {
                    pushpin.setOptions({ color: selectedValue.ChassisCurrentConditionID });
                }
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferHistoryMap);
                if (gridName == "chassisTrace") {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisHistoryInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisHistoryInfoboxOnClick(args); });
                }
                else {
                    Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisStatusInfobox(args); });
                    Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisStatusInfoboxOnClick(args); });
                }
                layer.add(pushpin);
            }
            PushpinsData.push(selectedValue);
        });
        reeferHistoryMap.layers.insert(layer);
    }
    static DisplayGensetSelectedPushpin(selectedRow: any) {        
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();
        calloutState = false;
        var isTrace = false;

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;
            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.GensetCurrentConditionId) {
                    if (value.GensetCurrentConditionId == selectedRow.GensetCurrentConditionId) {
                        rowIndex = index;
                        return false;
                    }
                } else if (value.GensetHistoryID) {
                    if (value.GensetHistoryID == selectedRow.GensetHistoryID) {
                        rowIndex = index;
                        isTrace = true;
                        return false;
                    }
                }
            });

            //var imageSource = 'genset_normal.png';   

            var imageSource = '';
            if (isTrace) {
                if (rowIndex == 0)
                    imageSource = pushpinyellow;
                else if (rowIndex == PushpinsData.length - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;
            }
            else {
                imageSource = pushpinyellow;
            }
            var pushpinImage = imageSource;

            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            if (isTrace) {
                pushpin.setOptions({ color: selectedRow.GensetHistoryID });
            } else {
                pushpin.setOptions({ color: selectedRow.GensetCurrentConditionId });
            }


            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferHistoryMap.setView({
                center: latLong,
                centerOffset: new Microsoft.Maps.Point(0, 30)//RCNG-227
            });

            pinInfobox.setMap(reeferHistoryMap);
            if (isTrace) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetHistoryInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetHistoryInfoboxOnClick(args); });
            } else {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetStatusInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetStatusInfoboxOnClick(args); });
            }

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0    
            reeferHistoryMap.layers.insert(traceLayer);    
        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferHistoryMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferHistoryMap.setView({
                center: center
            });

            toolTip.setMap(reeferHistoryMap);

        }
    }   
    static DisplayChassisSelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();
        calloutState = false;
        var isTrace = false;

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;
            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.ChassisCurrentConditionID) {
                    if (value.ChassisCurrentConditionID == selectedRow.ChassisCurrentConditionID) {
                        rowIndex = index;
                        return false;
                    }
                } else if (value.ChassisHistoryID) {
                    if (value.ChassisHistoryID == selectedRow.ChassisHistoryID) {
                        rowIndex = index;
                        isTrace = true;
                        return false;
                    }
                }
            });

            //var imageSource = 'genset_normal.png';   

            var imageSource = '';
            if (isTrace) {
                if (rowIndex == 0)
                    imageSource = pushpinyellow;
                else if (rowIndex == PushpinsData.length - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;
            }
            else {
                imageSource = pushpinyellow;
            }
            var pushpinImage = imageSource;

            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            if (isTrace) {
                pushpin.setOptions({ color: selectedRow.ChassisHistoryID });
            } else {
                pushpin.setOptions({ color: selectedRow.ChassisCurrentConditionID });
            }


            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferHistoryMap.setView({
                center: latLong,
                centerOffset: new Microsoft.Maps.Point(0, 30)//RCNG-227
            });

            pinInfobox.setMap(reeferHistoryMap);
            if (isTrace) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisHistoryInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisHistoryInfoboxOnClick(args); });
            } else {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisStatusInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisStatusInfoboxOnClick(args); });
            }

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0    
            reeferHistoryMap.layers.insert(traceLayer);
        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferHistoryMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferHistoryMap.setView({
                center: center
            });

            toolTip.setMap(reeferHistoryMap);

        }
    }   
    static DisplayDrySelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();
        calloutState = false;
        var isTrace = false;

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;
            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.DryCurrentConditionId) {
                    if (value.DryCurrentConditionId == selectedRow.DryCurrentConditionId) {
                        rowIndex = index;
                        return false;
                    }
                } else if (value.DCHistoryID) {
                    if (value.DCHistoryID == selectedRow.DCHistoryID) {
                        rowIndex = index;
                        isTrace = true;
                        return false;
                    }
                }
            });

            //var imageSource = 'purple_pushpin.png';
            var imageSource = '';
            if (isTrace) {
                if (rowIndex == 0)
                    imageSource = pushpinyellow;
                else if (rowIndex == PushpinsData.length - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;
            }
            else {
                imageSource = pushpinyellow;
            }

            var pushpinImage = imageSource;

            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            if (isTrace) {
                pushpin.setOptions({ color: selectedRow.DCHistoryID });
            } else {
                pushpin.setOptions({ color: selectedRow.DCCurrentConditionID });
            }


            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferHistoryMap.setView({
                center: latLong,
                centerOffset: new Microsoft.Maps.Point(0, 30)//RCNG-227
            });

            pinInfobox.setMap(reeferHistoryMap);
            if (isTrace) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryHistoryInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryHistoryInfoboxOnClick(args); });
            } else {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryStatusInfobox(args); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryStatusInfoboxOnClick(args); });
            }

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0    
            reeferHistoryMap.layers.insert(traceLayer);
        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferHistoryMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferHistoryMap.setView({
                center: center
            });

            toolTip.setMap(reeferHistoryMap);

        }
    } 
    static UpdateGensetGridName(gridname: any) {
        gridName = gridname;
    }
    static UpdateChassisGridName(gridname: any) {
        gridName = gridname;
    }
}
//class PanningOverlay extends Microsoft.Maps.CustomOverlay{
//     bounds: Microsoft.Maps.LocationRect;
//     private panUpBtn: HTMLInputElement;
//     private panDownBtn: HTMLInputElement;
//     private panLeftBtn: HTMLInputElement;
//     private panRightBtn: HTMLInputElement;

//     constructor(bounds: Microsoft.Maps.LocationRect) {
//            super({ beneathLabels: false });
//            this.bounds = bounds; 
           
//            this.panUpBtn = document.createElement('input');
//            this.panUpBtn.type = 'button';
//            this.panUpBtn.value = '˄';
//            this.panUpBtn.onclick = () =>{
//                this.panMap('up');
//            };
//            this.panDownBtn = document.createElement('input');
//            this.panDownBtn.type = 'button';
//            this.panDownBtn.value = '˅';
//            this.panDownBtn.onclick = () =>{
//                this.panMap('down');
//            };
//            this.panLeftBtn = document.createElement('input');
//            this.panLeftBtn.type = 'button';
//            this.panLeftBtn.value = '<';
//            this.panLeftBtn.onclick = () =>{
//                this.panMap('left');
//            };
//            this.panRightBtn = document.createElement('input');
//            this.panRightBtn.type = 'button';
//            this.panRightBtn.value = '>';
//            this.panRightBtn.onclick = () =>{
//                this.panMap('right');
//            };
       
//            }
//    onAdd(){
//            var container = document.createElement('div');
//            container.appendChild(this.panUpBtn);
//            container.appendChild(this.panDownBtn);
//            container.appendChild(this.panLeftBtn);
//            container.appendChild(this.panRightBtn);
//            container.style.position = 'absolute';
//            container.style.top = '10px';
//            container.style.left = '10px';
//            this.setHtmlElement(container);
//        }
//    panMap(dir: any){
//            var dx = 0, dy = 0;
//            switch (dir) {
//                case 'up':
//                    dy = -30;
//                    break;
//                case 'down':
//                    dy = 30;
//                    break;
//                case 'left':
//                    dx = -30;
//                    break;
//                case 'right':
//                    dx = 30;
//                    break;
//            }
//            var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter());
//            cp.x += dx;
//            cp.y += dy;
//            reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp) });
//        }
//}
function displayReeferHistoryInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target._options.color;
            var dataItem = null;
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].ParentEventID.toString() == eventId) {
                    dataItem = PushpinsData[i];
                    break;
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            
           var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id='+ identityCode +' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: dataItem, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });
           
            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayReeferHistoryInfobox(event) {
     if(calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                //var index1 = e.target.Description.indexOf("id=") + 3;
                //var index2 = e.target.Description.indexOf("style") - 1;
                //var unitMasterId = e.target.Description.substring(index1, index2);
                var eventId = event.target._options.color;
                var dataItem = null;
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ParentEventID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);
            
               var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id='+ identityCode +' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: dataItem, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });
           
                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}

function displayGensetHistoryInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                //var index1 = e.target.Description.indexOf("id=") + 3;
                //var index2 = e.target.Description.indexOf("style") - 1;
                //var unitMasterId = e.target.Description.substring(index1, index2);
                var eventId = event.target._options.color;
                var dataItem = null;                
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetCurrentConditionId) {
                        if (PushpinsData[i].GensetCurrentConditionId == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].GensetHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}
function displayChassisHistoryInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                var eventId = event.target._options.color;
                var dataItem = null;
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisCurrentConditionID) {
                        if (PushpinsData[i].ChassisCurrentConditionID == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}
function displayDryHistoryInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                //var index1 = e.target.Description.indexOf("id=") + 3;
                //var index2 = e.target.Description.indexOf("style") - 1;
                //var unitMasterId = e.target.Description.substring(index1, index2);
                var eventId = event.target._options.color;
                var dataItem = null;
                //for (var i = 0; i < PushpinsData.length; i++) {
                //    if (PushpinsData[i].GensetCurrentConditionId.toString() == eventId) {
                //        dataItem = PushpinsData[i];
                //        break;
                //    }
                //}
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DryCurrentConditionId) {
                        if (PushpinsData[i].DryCurrentConditionId == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}

function displayGensetHistoryInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target._options.color;
            var dataItem = null;            
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].GensetCurrentConditionId) {
                    if (PushpinsData[i].GensetCurrentConditionId == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].GensetHistoryID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayDryHistoryInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target._options.color;
            var dataItem = null;
            //for (var i = 0; i < PushpinsData.length; i++) {
            //    if (PushpinsData[i].GensetConditionLogID.toString() == eventId) {
            //        dataItem = PushpinsData[i];
            //        break;
            //    }
            //}
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].DryCurrentConditionId) {
                    if (PushpinsData[i].DryCurrentConditionId == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}
function displayChassisHistoryInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            var eventId = event.target._options.color;
            var dataItem = null;
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].ChassisCurrentConditionID) {
                    if (PushpinsData[i].ChassisCurrentConditionID == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}
function displayGensetStatusInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                //var index1 = e.target.Description.indexOf("id=") + 3;
                //var index2 = e.target.Description.indexOf("style") - 1;
                //var unitMasterId = e.target.Description.substring(index1, index2);
                var eventId = event.target._options.color;
                var dataItem = null;               
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetCurrentConditionId) {
                        if (PushpinsData[i].GensetCurrentConditionId == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}

function displayDryStatusInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                //var index1 = e.target.Description.indexOf("id=") + 3;
                //var index2 = e.target.Description.indexOf("style") - 1;
                //var unitMasterId = e.target.Description.substring(index1, index2);
                var eventId = event.target._options.color;
                var dataItem = null;
                //for (var i = 0; i < PushpinsData.length; i++) {
                //    if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
                //        dataItem = PushpinsData[i];
                //        break;
                //    }
                //}
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DryCurrentConditionId) {
                        if (PushpinsData[i].DryCurrentConditionId == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}
function displayChassisStatusInfobox(event) {
    if (calloutState) {
        calloutState = false;
        if (event.targetType == 'pushpin') {
            try {
                if (toolTip != null) {
                    toolTip.setOptions({ visible: false });
                    toolTip.setMap(null);
                }
                var eventId = event.target._options.color;
                var dataItem = null;
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisCurrentConditionID) {
                        if (PushpinsData[i].ChassisCurrentConditionID == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    } else {
                        if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (pinInfobox != null) {
                    pinInfobox.setOptions({ visible: false });
                }
                var popOffset = new Microsoft.Maps.Point(-4, 182);

                var identityCode = GenerateAlphaNumericCode(6);
                /* InfoBox Code Starts     */
                var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
                var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
                RCUtils.RenderChildComponent(identityCode, DescElement);

                // Create the infobox for the pushpin
                pinInfobox.setOptions({
                    maxHeight: 200,
                    maxWidth: 540,
                    showPointer: true,
                    description: description,
                    location: event.target.getLocation(),
                    visible: true, offset: popOffset,
                    showCloseButton: true
                });

                //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
                var buffer = 30;
                var infoboxOffset = pinInfobox.getOffset();
                var infoboxAnchor = pinInfobox.getAnchor();
                var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
                var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
                var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
                if (dy < buffer) {
                    //#### Offset in opposite direction.
                    dy *= -1;
                    //#### add buffer from the top edge of the map.
                    dy += buffer;
                }
                else {
                    //#### If dy is greater than zero than it does not overlap.
                    dy = 0;
                }
                if (dx < buffer) {
                    //#### Offset in opposite direction.
                    dx *= -1;
                    //#### add a buffer from the left edge of the map.
                    dx += buffer;
                }
                else {
                    dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                    //#### If dx is greater than zero then it does not overlap.
                    if (dx > buffer) {
                        dx = 0;
                    }
                    else {
                        //#### add a buffer from the right edge of the map.
                        dx -= buffer;
                    }
                }
                //#### Adjust the map so infobox is in view
                if (dx != 0 || dy != 0) {
                    //map.setView({
                    //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                    //    center: map.getCenter()
                    //});
                    var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                    cp.x -= dx;
                    cp.y -= dy;
                    reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
                }
            }
            catch (ex) {
                //alert(ex.message + " " + ex.description);
            }
        }
    }
}
function displayGensetStatusInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target._options.color;
            var dataItem = null;            
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].GensetCurrentConditionId) {
                    if (PushpinsData[i].GensetCurrentConditionId == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayDryStatusInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target._options.color;
            var dataItem = null;
            //for (var i = 0; i < PushpinsData.length; i++) {
            //    if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
            //        dataItem = PushpinsData[i];
            //        break;
            //    }
            //}
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].DCCurrentConditionID) {
                    if (PushpinsData[i].DCCurrentConditionID == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayChassisStatusInfoboxOnClick(event) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            var eventId = event.target._options.color;
            var dataItem = null;
            for (var i = 0; i < PushpinsData.length; i++) {
                if (PushpinsData[i].ChassisCurrentConditionID) {
                    if (PushpinsData[i].ChassisCurrentConditionID == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                } else {
                    if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                        dataItem = PushpinsData[i];
                        break;
                    }
                }
            }
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferHistoryMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferHistoryMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferHistoryMap.tryLocationToPixel(reeferHistoryMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferHistoryMap.setView({ center: reeferHistoryMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}
function hideReeferInfobox(e) {
    if (pinInfobox != null) 
        pinInfobox.setOptions({ visible: false });
}

function ClearMapLayers() {
    if (layer != null)
        layer.clear();
    if (traceLayer != null)
        traceLayer.clear();
    if (geoZonesLayer != null)
        geoZonesLayer.clear();
}

function GenerateAlphaNumericCode(length) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        result = ""
    for (var i = length; i > 0; --i)
        result += chars[Math.round(Math.random() * (chars.length - 1))]
    return result
}

function clearInfoboxPopup() {
    if (pinInfobox != null) {
        pinInfobox.setOptions({ visible: false });
        pinInfobox.setMap(null);
    }
    if (toolTip != null) {
        toolTip.setOptions({ visible: false });
        toolTip.setMap(null);
    }
}
function mapTypeChanged(params) {
    var mapType = reeferHistoryMap.getImageryId();
    if (mapType == "Aerial") {        
        $("#geoZones").removeClass('map-Geofence');
        $("#geoZones").addClass('mapGeofenceAerial');
        DryMapGrid.UpdateFenceImage('A');
    }
    else {        
        $("#geoZones").removeClass('mapGeofenceAerial');
        $("#geoZones").addClass('map-Geofence');  
        DryMapGrid.UpdateFenceImage('R');
    }
}
export default MapCallout;